module.exports = __webpack_public_path__ + "static/media/thumb-up-svgrepo-com (8).38496598.svg";